export default __webpack_public_path__ + "static/media/videos.87350b41.svg";